export default __webpack_public_path__ + "assets/images/b1f928ae1682d814436b3e13b553860e.svg";